import React, { useState } from "react";
import { useParams } from "react-router-dom";
import ProductList from "../../AdminDashboard/productlist/Productlist";

function SellerStoreInformation() {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState("products");

  const tabs = [
    { id: "products", label: "Products" },
    { id: "category", label: "Category" },
    { id: "orders", label: "View Orders" },
  ];

  return (
    <div className="container my-4">
      <h3 className="mb-4">Seller Store Information</h3>

      {/* Tab buttons */}
      <div className="border-bottom d-flex flex-wrap gap-3">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`btn border-0 border-bottom ${
              activeTab === tab.id
                ? "border-primary text-primary fw-semibold"
                : "text-muted"
            }`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab content */}
      <div className="tab-content mt-4">
        {activeTab === "products" && <ProductList />}
        {activeTab === "category" && <div>{/* Category content */}</div>}
        {activeTab === "orders" && <div>{/* Orders content */}</div>}
      </div>
    </div>
  );
}

export default SellerStoreInformation;
